import React from 'react'

const TimeLinePriceContainer = ({ children }) => {
  return (
    <div className="mb-0015 w-60p">
      {children}
    </div>
  )
}

export default TimeLinePriceContainer
